document.addEventListener('DOMContentLoaded', function() {
    const asideEls = document.querySelectorAll('aside section');

    for (let index = 0; index < asideEls.length; index++) {
       const element = asideEls[index];
       element.classList.add('module');

       if (index === asideEls.length - 1) {
           element.classList.remove('module');
           element.classList.add('sticky', 'top-10');
       }
    }
});